import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Helmet } from 'react-helmet';

import S01 from './s01';
import S02 from './s02';
import S03 from './s03';
import S04 from './s04';
import S05 from './s05';
import S06 from './s06';
import S07 from './s07';

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  return (
    <main>
      <Helmet>
        <title>LEVRAI</title>
        <link rel="canonical" href="https://www.levraiglobal.com/" />
      </Helmet>
      <S01 />
      <S02 />
      <S03 />
      <S04 />
      <S05 />
      <S06 />
      <S07 />
    </main>
  );
};

export default Home;
